import React from 'react';
import { Html } from '@react-three/drei';
import { soundon } from '../assets/icons';

const Loader = () => {
  return (
    <Html>
      {/* <img src={"loading_page.jpg"} alt="loading" className="h-100 w-100" /> */}
      <div className='flex flex-col justify-center items-center'>
        <div className='w-20 h-20 border-2 border-opacity-20 border-white-500 border-t-red-500 rounded-full animate-spin'>
        </div>
      </div>
      {/* <div className='absolute  w-60 h-30 text-center  text-black-500 font-semibold text-xl'>
        Kindly wait for the 3-D model to load. Click on the <img src={soundon} alt='sound' className='w-8 h-8 cursor-pointer object-contain'/> icon to chill to some music while waiting...
      </div> */}
    </Html>
  );
};

export default Loader;
